import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('a_new_version_is_available'),
    description: defineMessage('we_have_noticed_you_are_versionbrof_approvalmax'),
    reloadText: defineMessage('please_reload_the_page__the_most_recent_version'),
    reload: defineMessage('reload'),
};
